import './glow-button.css'

import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react'

import classNames from '../../utils/classNames'

interface GlowButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode | string
  className?: string
  width?: CSSProperties['width']
  variant?: 'green' | 'blue' | 'orange'
}

const GlowButton = ({
  children,
  className = '',
  width,
  style = {},
  variant = 'orange',
  ...rest
}: GlowButtonProps) => {
  return (
    <button
      className={classNames(
        'flx-ctr text-white font-bold uppercase rounded-md transition-all dark:font-extrabold dark:tracking-[0.02em] disabled:opacity-50 disabled:pointer-events-none',
        variant === 'green' && 'glow-btn-green',
        variant === 'blue' && 'glow-btn-blue',
        variant === 'orange' && 'glow-btn-orange',
        className,
      )}
      style={{ width, ...style }}
      {...rest}>
      {children}
    </button>
  )
}

export default GlowButton
